import Modal from "../../Dashboard/Modal";
import { Link } from "react-router-dom";
import Input from "../fields/Input";
import CreditCardInput from "../fields/Credit-Card-input";
import { CardNumberElement, CardCvcElement, CardExpiryElement } from "@stripe/react-stripe-js";
import Message from "../fields/Message";
import { CiCreditCard1 } from "react-icons/ci";
import { FiLock } from "react-icons/fi";

export default function PaymentModal({
	cardName,
	setCardName,
	cardNumber,
	mmYy,
	setMmYy,
	cvc,
	zipCode,
	setZipCode,
	defaultSelection,
	setDefaultSelection,
	handleSubmitCard,
	paymentMessage,
	resetWarnings,
	OkButtonText,
	editCard,
	AllowDefaultSelect,
}) {
	const customStyles = {
		style: {
			base: {
				fontSize: "1rem",
				lineHeight: "1.8",
				color: "#333",
				"::placeholder": {
					color: "#aab7c4",
				},
			},
			invalid: {
				color: "#dc3545",
			},
		},
	};

	const cardNumberElementOptions = {
		...customStyles,
		placeholder: "1234 5678 9012 3456",
		showIcon: true,
		disableLink: true,
	};

	const cardExpiryElementOptions = {
		...customStyles,
		placeholder: "MM / YY",
	};

	const cardCvcElementOptions = {
		...customStyles,
		placeholder: "123",
	};

	const paymentElement = document.getElementsByClassName("__PrivateStripeElement");
	if (paymentElement) {
		for (let i = 0; i < paymentElement.length; i++) {
			paymentElement[i].style.height = "100%";
		}
	}

	return (
		<Modal
			title=""
			bodyClass="p-0"
			btnText={editCard ? "Edit Payment Card" : "Add New Payment"}
			trigger="paymentForm"
			showBtn={false}
			size={"md"}
			close={false}
			modalHeader={false}
		>
			<form
				className="w-100"
				onSubmit={(e) => handleSubmitCard(e)}
			>
				<div className="px-4 pt-4 pb-2">
					<div className="d-flex align-items-center mb-3">
						<CiCreditCard1 size={28} className="text-primary me-2" />
						<h5 className="fw-bold m-0">{editCard ? "Edit Card" : "Add Payment Method"}</h5>
					</div>

					{paymentMessage.show && (
						<div className="mb-3">
							<Message message={paymentMessage} />
						</div>
					)}

					<div className="mb-3">
						<label className="form-label small fw-semibold text-muted">Cardholder Name</label>
						{editCard ? (
							<input
								type="text"
								className="form-control"
								value={cardName}
								disabled
							/>
						) : (
							<Input
								type="text"
								value={cardName}
								name=""
								showLabel={false}
								placeholder="John Doe"
								fn={setCardName}
								isDisabled={editCard ? true : false}
							/>
						)}
					</div>

					<div className="mb-3">
						<label className="form-label small fw-semibold text-muted">Card Number</label>
						{cardNumber ? (
							<CreditCardInput
								type="text"
								value={cardNumber}
								name=""
								showLabel={false}
								placeholder="Card Number"
								paymentcard={true}
								editCard={editCard}
								isDisabled={true}
								fn={() => {}}
							/>
						) : (
							<CardNumberElement className="form-control py-2" options={cardNumberElementOptions} />
						)}
					</div>

					<div className="row">
						<div className="col-4 mb-3">
							<label className="form-label small fw-semibold text-muted">Expiry</label>
							{mmYy ? (
								<Input
									type="text"
									value={mmYy}
									name=""
									showLabel={false}
									placeholder="MM / YY"
									fn={setMmYy}
								/>
							) : (
								<CardExpiryElement className="form-control py-2" options={cardExpiryElementOptions} />
							)}
						</div>

						<div className="col-4 mb-3">
							<label className="form-label small fw-semibold text-muted">CVC</label>
							{cvc ? (
								<Input
									type="text"
									value={cvc}
									name=""
									showLabel={false}
									placeholder="CVC"
									fn={() => {}}
									mask={editCard ? "" : "999"}
									isDisabled={true}
								/>
							) : (
								<CardCvcElement className="form-control py-2" options={cardCvcElementOptions} />
							)}
						</div>

						<div className="col-4 mb-3">
							<label className="form-label small fw-semibold text-muted">Zip Code</label>
							<Input
								type="text"
								value={zipCode}
								name=""
								showLabel={false}
								placeholder="10001"
								fn={setZipCode}
								mask="99999999"
							/>
						</div>
					</div>

					{AllowDefaultSelect && (
						<div className="mb-2">
							<div className="d-flex align-items-center">
								<input
									className="form-check-input custom-checkbox m-0"
									type="checkbox"
									id="defaultPaymentCheckbox"
									checked={defaultSelection}
									onChange={() => setDefaultSelection(!defaultSelection)}
								/>
								<label
									role="button"
									className="form-check-label text-muted ms-2 small"
									htmlFor="defaultPaymentCheckbox"
								>
									Set as default payment method
								</label>
							</div>
						</div>
					)}
				</div>

				<div className="px-4 py-3 bg-light rounded-bottom d-flex align-items-center justify-content-between">
					<div className="d-flex align-items-center text-muted small">
						<FiLock size={14} className="me-1" />
						<span>Secured by Stripe</span>
					</div>
					<div className="d-flex gap-2">
						<Link
							to="#"
							className="d-block text-decoration-none paymentmodal"
							data-bs-toggle="modal"
							data-bs-target="#paymentForm"
						>
							<button
								className="btn btn-outline-secondary px-4"
								type="button"
								onClick={() => resetWarnings()}
							>
								Cancel
							</button>
						</Link>
						<button
							id="paymentSubmit"
							className="btn btn-primary px-4"
							type="submit"
						>
							{OkButtonText}
						</button>
					</div>
				</div>
			</form>
		</Modal>
	);
}
